import { render, staticRenderFns } from "./settings-bank-details-form.vue?vue&type=template&id=6576537a&scoped=true&"
import script from "./settings-bank-details-form.vue?vue&type=script&lang=js&"
export * from "./settings-bank-details-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6576537a",
  null
  
)

export default component.exports